import { Component } from "@angular/core";
import { NavController } from "ionic-angular";
import { AngularFire, FirebaseListObservable } from "angularfire2";
import { DomSanitizer } from "@angular/platform-browser";
import { FileService } from "../../providers/file";
import { StatsService } from "../../providers/stats";
import { Settings } from "../settings/settings";
import moment from "moment";
import "rxjs/add/operator/take";

@Component({
  selector: "page-home",
  templateUrl: "home.html",
})
export class Home {
  options: any = [
    { title: "New Article", icon: "ios-paper-outline", link: "Article" },
    { title: "Public Posts", icon: "ios-document-outline", link: "Posts" },
    { title: "Private Posts", icon: "ios-lock-outline", link: "Contents" },
    { title: "Blocked", icon: "ios-person-outline", link: "Users" },
    { title: "Reported", icon: "ios-flag-outline", link: "Reported" },
    { title: "Export Data", icon: "ios-download-outline", link: "Export" },
  ];

  users: FirebaseListObservable<any[]> = null;
  publicPosts: FirebaseListObservable<any[]> = null;
  privatePosts: FirebaseListObservable<any[]> = null;

  exportLink: any = null;

  constructor(
    public sanitizer: DomSanitizer,
    public navCtrl: NavController,
    public fileService: FileService,
    public statsService: StatsService,
    public af: AngularFire,
  ) {
    this.users = this.af.database.list("/users", {
      query: {
        orderByChild: "timestamp",
        limitToLast: 5,
      },
    });

    this.publicPosts = this.af.database.list("/posts", {
      query: {
        orderByChild: "type",
        limitToLast: 5,
        equalTo: "post",
      },
    });

    this.privatePosts = this.af.database.list("/private", {
      query: {
        limitToLast: 5,
      },
    });
  }

  ionViewDidEnter() {}

  onNotifications() {}

  onSettings() {
    this.navCtrl.push(Settings, {});
  }

  onProfile() {}

  onLogout() {
    this.af.auth.logout();
  }

  onExportStats() {
    return this.statsService.getStatsJson().then((json: any) => {
      let currentDate = moment().format("YYYY-MM-DD-HH-mm-ss");
      let filename = `stats-${currentDate}.json`;

      return this.fileService.createAndDownloadFile(
        filename,
        "text/json",
        JSON.stringify(json),
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts